import Color from "color";
import get from "lodash/get";
import { getTextColor } from "../../utils/getTextColor";

const FALLBACK_BRAND = "#1A73E8";
const DEFAULT_BOT_NAME = "Zoya";

const parseColor = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    return Color(value.trim());
  } catch (e) {
    return null;
  }
};

export const getBotName = (organization) => {
  const name = get(organization, "bot_setting.bt_name");
  return typeof name === "string" && name.trim()
    ? name.trim()
    : DEFAULT_BOT_NAME;
};

export const getChatTheme = (defaultColor) => {
  const parsed = parseColor(defaultColor) || Color(FALLBACK_BRAND);
  const brand = parsed.rgb().string();

  const tint = (alpha) => parsed.alpha(alpha).rgb().string();

  const darker = (() => {
    try {
      return parsed.darken(0.2).rgb().string();
    } catch (e) {
      return brand;
    }
  })();

  const onBrand = (() => {
    try {
      return getTextColor(brand);
    } catch (e) {
      return "#ffffff";
    }
  })();

  return {
    "--cb-brand": brand,
    "--cb-brand-dark": darker,
    "--cb-on-brand": onBrand,
    "--cb-tint-07": tint(0.07),
    "--cb-tint-12": tint(0.12),
    "--cb-tint-30": tint(0.3),
    "--cb-focus": tint(0.35),
  };
};

export { FALLBACK_BRAND, DEFAULT_BOT_NAME };
